"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const HasLength_1 = require("../../shared/HasLength");
const HasSize_1 = require("../../shared/HasSize");
class HasMaxNumberOfElementsValidator {
    constructor(maxElementCount) {
        this.maxElementCount = maxElementCount;
    }
    isValid(input) {
        if (HasLength_1.hasLength(input)) {
            return input.length <= this.maxElementCount;
        }
        else if (HasSize_1.hasSize(input)) {
            return input.size <= this.maxElementCount;
        }
        else {
            return false;
        }
    }
}
exports.HasMaxNumberOfElementsValidator = HasMaxNumberOfElementsValidator;
//# sourceMappingURL=HasMaxNumberOfElementsValidator.js.map